import { ComponentProps } from 'react'
import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import { PageCTALink } from '../../../components/landing/display'

export const CTAAnnotation = styled.p`
  ${typeStyle('-ds-font-section-title-light')}
  margin: 0;
`

type GetStartedCTAProps = {
  search: string
  isInvited?: boolean
} & ComponentProps<typeof PageCTALink>

export const GetStartedCTA = ({
  isInvited,
  search,
  info,
  noMarginTop,
}: GetStartedCTAProps) => {
  const href = isInvited ? `/set-password${search}` : '/my/listings/new'

  return (
    <PageCTALink href={href} info={info} noMarginTop={noMarginTop} rounded>
      Get Started
    </PageCTALink>
  )
}
